import { TAB_META } from "../lib/tabs";
import type { TabId } from "../lib/tabs";

/**
 * StatusBar — spec §2.3 / §2.12.
 *
 * Always-visible top row showing channel code + state + voice slot.
 * Phase 1 keeps the state hardcoded to STBY; later phases will wire in the
 * live session state.
 */
export function StatusBar({
  tab,
  onOpenSettings,
}: {
  tab: TabId;
  onOpenSettings: () => void;
}) {
  const meta = TAB_META[tab];
  const voiceSlot = voiceSlotFor(tab);

  return (
    <header
      className="sticky top-0 z-20 border-b border-ink/15 bg-cream/95 backdrop-blur-sm"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-3 font-mono text-[11px] tracking-[0.14em]">
          <span className="rounded-sm bg-ink px-2 py-0.5 text-cream">
            {meta.code}
          </span>
          <span className="text-ink">STBY</span>
          <span className="text-subtext">│</span>
          <span className="text-subtext">{voiceSlot}</span>
        </div>

        <button
          type="button"
          onClick={onOpenSettings}
          className="font-mono text-[11px] tracking-[0.14em] text-subtext hover:text-ink"
          aria-label="Settings"
        >
          ⚙ CFG
        </button>
      </div>
    </header>
  );
}

function voiceSlotFor(tab: TabId): string {
  // Tsuyaku: dynamic voice, no user selection (spec §2.12).
  // Okoshi: text-only, no voice slot.
  // Zasso: user-selected voice (placeholder until §2.7 settings wire up).
  if (tab === "tsuyaku") return "DYN-VOICE";
  if (tab === "okoshi") return "TEXT-ONLY";
  return "verse";
}
